import type { SVGProps } from 'react';

const SvgPending = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M15 12h-2V8c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M12 3c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9m0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7"
    />
  </svg>
);
export default SvgPending;
